import { $OpenApiTs } from 'app/API';

export type TAuditBusinessAction = NonNullable<
  $OpenApiTs['/api/admin/audit-logs']['get']['req']['businessAction']
>[number];

const auditBusinessActionByName = {
  SUBSCRIPTION_PROVISIONED: 'SUBSCRIPTION_PROVISIONED',
  SUBSCRIPTION_UPGRADED: 'SUBSCRIPTION_UPGRADED',
  SUBSCRIPTION_SEATS_UPDATED: 'SUBSCRIPTION_SEATS_UPDATED',
  SUBSCRIPTION_CANCELED: 'SUBSCRIPTION_CANCELED',
  SUBSCRIPTION_DELETED: 'SUBSCRIPTION_DELETED',
  SUBSCRIPTION_SYNCED_FROM_STRIPE: 'SUBSCRIPTION_SYNCED_FROM_STRIPE',
  SUBSCRIPTION_PAYMENT_RETRIED: 'SUBSCRIPTION_PAYMENT_RETRIED',
  ONE_TIME_SUBSCRIPTION_EXPIRED: 'ONE_TIME_SUBSCRIPTION_EXPIRED',
  LICENSE_ASSIGNED: 'LICENSE_ASSIGNED',
  LICENSE_SETTINGS_UPDATED: 'LICENSE_SETTINGS_UPDATED',
  ORGANIZATION_CREATED: 'ORGANIZATION_CREATED',
  ORGANIZATION_UPDATED: 'ORGANIZATION_UPDATED',
  ORGANIZATION_SOFT_DELETED: 'ORGANIZATION_SOFT_DELETED',
  ORGANIZATION_MEMBER_ADDED: 'ORGANIZATION_MEMBER_ADDED',
  ORGANIZATION_MEMBER_DISABLED: 'ORGANIZATION_MEMBER_DISABLED',
  ORGANIZATION_MEMBER_REMOVED: 'ORGANIZATION_MEMBER_REMOVED',
  ORGANIZATION_MEMBER_UPDATED: 'ORGANIZATION_MEMBER_UPDATED',
  ORGANIZATION_MEMBER_TEAMS_CHANGED: 'ORGANIZATION_MEMBER_TEAMS_CHANGED',
} satisfies { [K in TAuditBusinessAction]: K };

export const auditBusinessActions = Object.values(auditBusinessActionByName);
